import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../../service/Util/Util'; // Default Environment Value
import { ShareDataService } from './../../../service/share-data/share-data.service';
import { CustomModalService } from './../../../component/modal/custom-modal.service';
import { Component, ViewChild, Input, Output, ElementRef, EventEmitter,HostListener } from '@angular/core';
import { navItems } from '../../../_nav';
import { StorageService } from '../../../service/storage/storage.service';
import { RequestService } from '../../../service/api/request.service';
import { CustomModalConfig } from '../../../component/modal/custom-modal.config.interface';
import { AuthGuardService } from '../../../service/auth/auth-guard.service';
import { MobileModeGuardService } from '../../../service/mobilemodecheck/mobilemode-guard.service';
import { getAllContract , TermSelectContainer} from '.././../../pages/terms/term-select';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {
  @ViewChild('aForm') aForm: ElementRef;
  @Input() continueForgotpassRegister;
  @Output() setContinueRegisterParent = new EventEmitter<any>();
  @Output() checkChangeTermEmiter = new EventEmitter<any>();
  @Output() hideBtnChangeTermMobileEmitter = new EventEmitter<any>();

  primaryColor: string;
  token : any;
  setting;
  navbarBrand = '';
  layoutColor = '';
  layoutLogo = '';
  schoolLogo = '';
  layoutName = 'Parent Portal';
  headerTitle = '';

  term_name_active:string = '';
  term_active_style:object = {};

  footerTitle = 'Parent Portal';
  layoutTitleColor = '#AAA';
  parentPortalText = '#FFF';
  objectImg = {}
  objectImgMini = {}
  customModalLoginConfig: CustomModalConfig = {
    title: '',
    content:'',
    type:''
  }
  accountDetail = {};
  AllContractResult : any;
  configModalShowTermSelect: CustomModalConfig = {
    title: '',
    content:'',
    type:''
  };
  childrenListResult;
  public sidebarMinimized = false;
  public navItems: any;
  @ViewChild('isLogedOut') isLogedOut
  isMobile
  navbarBrandRouterLink
  checkChangeTerm = false;
  hideBtnChangeTermMobile = false;
  userData;

  styleTermBtn:object = {}
  isBtnDisabled = false;
  term_active_style_mobile = {};

  constructor(
    private util: UtilService,
    private storageService : StorageService,
    private requestService: RequestService,
    private customModalService: CustomModalService,
    private shareDataService: ShareDataService,
    private router: Router ,
    private authGaurd: AuthGuardService,
    private activatedRoute: ActivatedRoute,
    private mobileModeService: MobileModeGuardService,
    private termSelectContainer: TermSelectContainer
  ){}

  changeTheme(primary: string, secondary: string) {
    document.documentElement.style.setProperty('--primary-color', primary);
  }

  async ngOnInit() {
    document.documentElement.style.setProperty('--primary-color', this.layoutColor);
    this.initial()
    this.initToken();
    this.initListner();
    this.checkChangeTermEmiter.subscribe(async (data) => {
      this.checkChangeTerm = data;
    })
    this.hideBtnChangeTermMobileEmitter.subscribe(async (data) => {
      this.hideBtnChangeTermMobile = data;
      const getTermActive = JSON.parse(this.storageService.getStorage('term_active'));
      const hsl_LColor = this.termSelectContainer.hexToHSL(getTermActive.term_colour);
      const colorText = hsl_LColor > 0.5 ? '#000' : '#fff';
      this.term_active_style_mobile = {'background-color': getTermActive.term_colour,'color':colorText,'z-index' : 1, 'visibility' : this.hideBtnChangeTermMobile ? 'hidden' : 'visible'}
    })

    this.termSelectContainer.setTermNameColor.subscribe(async (data) => {
      this.setTermNameColorActive(data.term_name,data.term_colour);
    })
  }

  /**
    * 
    * @param token   userParentToken
    */
   parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  async initial(){
    
    let parentApi = this.requestService.getParentAPI();
    this.accountDetail = this.util.getEnv();
    this.navItems = navItems

    await parentApi.checkRequestSecretFirst();

    let params = "?site_id="+this.accountDetail['site_id'];
    this.setting = await parentApi.get(
      parentApi.route.setting,
      params, 
      parentApi.requestSecret()
    );
    let accountInfo = this.setting['setting']['account_detail'][0];
    let companyInfo = this.setting['setting']['company_detail'][0];
    this.headerTitle = this.setting['setting']['header_title'] ? this.setting['setting']['header_title'] : 'Parent Portal';
    this.layoutColor      = !! accountInfo['colour'] ?  accountInfo['colour'] : this.layoutColor;
    this.layoutTitleColor = !! accountInfo['theme_title_colour']  ?    accountInfo['theme_title_colour'] : this.layoutTitleColor ;
    this.layoutName       = !! accountInfo['name'] ? accountInfo['name'] : this.layoutName;
    this.footerTitle      = !! companyInfo['company_name'] ? companyInfo['company_name'] : this.footerTitle
    this.layoutLogo       = !! accountInfo['img_logo_white'] ? accountInfo['img_logo_white'] : 'assets/img/images/account_logo_white.png';
    let _schoolLogo       = !! companyInfo['inv_logo'] ? this.accountDetail['ecm_site_url']+'/images/'+companyInfo['inv_logo'] : this.layoutLogo;
    this.schoolLogo       = (!!this.layoutLogo ? this.layoutLogo : _schoolLogo);
    
    const term_active = await this.storageService.getStorage('term_active');
    this.userData  = await this.storageService.getStorage('user');
    if(term_active){
      const term_active_json = JSON.parse(term_active);
      this.setTermNameColorActive(term_active_json.term_name,term_active_json.term_colour);
    }
    // Setting School Logo
    this.objectImg = { 
      src: this.schoolLogo, 
      height: 70, 
      alt: this.layoutName,
      class: 'logo-image'
    }
    this.objectImgMini = { 
      src: this.schoolLogo, 
      width: 30,
      height: 30,
      alt: this.layoutName,
      class: 'img-fluid'
    }
    // setting layout text and color
    this.parentPortalText = this.setting['setting']['parentPortalText'];
    await document.documentElement.style.setProperty('--primary-color', this.layoutColor);
    await document.documentElement.style.setProperty('--second-color', this.layoutTitleColor);
  }

  ngAfterViewInit(){
    this.controllNavIcon();
  }

  controllNavIcon(){
    this.util.controlNavIcon();
    let lateRoute = JSON.parse(this.storageService.getStorage("lateRoute"));
    let navigate = (lateRoute?.['isShowLateRoute']) ? lateRoute['job_name'] : 'home';
    this.navbarBrandRouterLink = navigate;
  }
  
  async initToken() {
    let userToken  = await this.storageService.getStorage('user'); 
    let mobileMode = await this.storageService.getStorage('mobileMode'); 
    if(mobileMode){ // check mobileMode
      this.isMobile = await this.mobileModeService.canActivate(userToken);
      await document.documentElement.style.setProperty('--toTopMobileMode', '0px'); // set margin bottom when is mobile mode
      await document.documentElement.style.setProperty('--backBtnMobileMode', 'block'); // set display back button on mobile mode
    }else{
      await document.documentElement.style.setProperty('--toTopMobileMode', '36px'); // set margin bottom when is not mobile mode
      await document.documentElement.style.setProperty('--backBtnMobileMode', 'none'); // set hide back button when is not mobile mode
    }

    let userlogin = await this.storageService.getStorage('user');
    if(userlogin){
      userlogin = JSON.parse(userlogin);
      this.token = { Token : userlogin.token };
    }
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  sendTriggerFocusInputLogin(e){
    console.log('sendTriggerFocusInputLogin', e)
    let msg = JSON.stringify({
      event: 'FOCUS_LOGIN',
    })
    this.shareDataService.changeMessage(msg)
  }

  initListner() {
    this.shareDataService.currentMessage.subscribe((res) => {
      try {
          let msg = JSON.parse(res);
          let status = msg.data?.status;
          let statusText = msg.data?.statusText;
          if (msg.event == AuthGuardService.EVENT.LOGIN_REQUIRED)
          {
            this.setModal("<i class='c-icon c-icon-2xl fa fa-user-times fa-lg'></i> Login Required", "Please login to continue", "danger")
            this.customModalService.open('custom-modal-login');
          }
          else if (msg.event == AuthGuardService.EVENT.LOGIN_TOKEN_EXPIRE)
          {
            this.token = null
            this.setModal("<i class='c-icon c-icon-2xl fa fa-user-times fa-lg'></i> Login Required", "Your session has expired, Please login to continue", "danger");
            this.customModalService.open('custom-modal-login');
            let lateRoute = JSON.parse(this.storageService.getStorage("lateRoute"));
            let navigate = (lateRoute?.['isShowLateRoute']) ? lateRoute['job_name'] : 'home';
            this.router.navigate([navigate]);
          }
          else if (msg.event == AuthGuardService.EVENT.LOGIN_ERROR
            && status == 401)
          {
            // No', let check webservice and parent app first then make this dynamic form ws
            statusText = 'Please check the details entered are correct and try again';
            this.setModal("<i class='c-icon c-icon-2xl fa fa-user-times fa-lg'></i> Login Failed", statusText, "danger")
            this.customModalService.open('custom-modal-login');
          }
          else if (msg.event == AuthGuardService.EVENT.LOGIN_SUCCESS)
          {
            this.initToken();
          }
      } catch (error) {
        // console.log(error);
      }
    });
  }

  setModal(title, content, type) {
    this.customModalLoginConfig.title = title
    this.customModalLoginConfig.content = content
    this.customModalLoginConfig.type = type
  }

  async navBarClick(e) {
    let element = e.target.offsetParent.firstElementChild
    if (element && element.attributes['calendarexceptionmodal']) {
      let isLogin = await this.authGaurd.canActivate();
      if (isLogin) {
        this.setModal(
          "<i class='c-icon c-icon-2xl fa fa-user-o fa-lg'></i> Passenger lists", 
          "", 
          "primary"
          )
        this.customModalService.open('custom-calandar-exception-layout');    
      }

      // get list passenger
      let parentApi = this.requestService.getParentAPI();
      this.childrenListResult = await parentApi.get(parentApi.route.mychildren,'', parentApi.requestHeaderUser()); // Get Bus Route with API // Get Bus Route with API
      console.log("childrenList ==> ", this.childrenListResult['result']);
      this.childrenListResult = this.childrenListResult['result'];
      for(let [index,children] of this.childrenListResult.entries()){
        if(this.childrenListResult[index]['route']['AM'][index] !== undefined){
          let childName = this.childrenListResult[index]['passenger_name'];
          let childId = this.childrenListResult[index]['passenger_id'];
          let route = this.childrenListResult[index]['route'];
          let assign_daysAM = '';
          let assign_daysPM = '';
  
          if(children['route']['AM'][index] !== undefined){
            assign_daysAM = children['route']['AM'][index]['assign_days'];
            children['route']['AM'][index]['dow'] = this.util.assignDaysOfWeek(children['route']['AM'][index]['assign_days'],false);
          }else{
            assign_daysAM = '';
          }
  
          if(children['route']['PM'][index] !== undefined){
            assign_daysPM = children['route']['PM'][index]['assign_days'];
            children['route']['PM'][index]['dow'] = this.util.assignDaysOfWeek(children['route']['PM'][index]['assign_days'],false);
          }else{
            assign_daysPM = '';
          }
        }else{
          // console.log("not route");
        }
      }
      // End get list passenger
      
    }
  }

  async changeTermSelect(){
    const term_active = await this.storageService.getStorage('term_active');
    this.AllContractResult = await this.storageService.getStorage("AllContract");
    this.AllContractResult = JSON.parse(this.AllContractResult);
    if(this.AllContractResult.length > 1){
      if(term_active){
        const TextAllContract = await getAllContract(this.requestService, false);
        this.AllContractResult = JSON.parse(TextAllContract);
        await this.openModalShowTermSelectChange()
      }
    }
  }

  async openModalShowTermSelectChange(){
    this.configModalShowTermSelect = {
      title: 'Please select the term you would like to manage.',
      content: '',
      type: 'info',
      backdrop : 'static',
      showOkButton : false,
    }
    this.customModalService.open('show-term-select-change');
  }

  cancelshowtermselect(){
    this.customModalService.close('show-term-select-change');
  }
  
  changTermFunc(contractID,open_booking,term_name,term_colour){
    if(!this.checkChangeTerm ){
      this.setTermNameColorActive(term_name,term_colour)
    }
    this.cancelshowtermselect();
    this.termSelectContainer.changeActive(contractID,open_booking,term_name,term_colour,this.checkChangeTerm );
  }

  setTermNameColorActive(term_name,term_colour){
    const hsl_LColor = this.termSelectContainer.hexToHSL(term_colour);
    const colorText = hsl_LColor > 0.5 ? '#000' : '#fff';
    this.term_name_active = term_name;
    this.term_active_style_mobile = {'background-color': term_colour,'color':colorText, 'z-index' : 1, 'visibility' : this.hideBtnChangeTermMobile ? 'hidden' : 'visible'}
    this.term_active_style = {'background-color': term_colour,'color':colorText,'width':'100%'}
  }
}
